module.exports = __webpack_public_path__ + "media/images/info-842148b02851caf4983cbe9e1c8908e2.svg";